var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59109 6.67L0.857103 7.64969L0.743385 7.67263C0.00820208 7.86393 -0.262009 8.80377 0.302585 9.35487L5.17609 14.112L4.02603 20.8312L4.01303 20.9413C3.96381 21.7028 4.77732 22.2535 5.47752 21.8849L11.5011 18.713L17.5242 21.8849L17.6249 21.9313C18.3337 22.214 19.1093 21.6112 18.9757 20.8312L17.8251 14.112L22.6996 9.35487L22.7781 9.26943C23.2601 8.68229 22.9258 7.76328 22.1451 7.64969L15.4101 6.67L12.3981 0.55797C12.0315 -0.18597 10.9707 -0.185996 10.6041 0.557927L7.59109 6.67ZM11.5001 3.262L13.8484 8.02561L13.9091 8.132C14.065 8.36971 14.3163 8.53168 14.6014 8.57317L19.8541 9.337L16.0526 13.0482L15.9704 13.1389C15.793 13.3605 15.7169 13.6491 15.7654 13.9326L16.6621 19.171L11.9669 16.6988L11.8551 16.6484C11.5891 16.5476 11.2904 16.5644 11.0352 16.6987L6.33909 19.17L7.23675 13.9327L7.25 13.811C7.26342 13.5275 7.15549 13.2492 6.94961 13.0482L3.14709 9.337L8.40036 8.57316C8.72619 8.52575 9.0078 8.32099 9.15335 8.02566L11.5001 3.262Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ea55eb0f.svg";
export { ForwardRef as ReactComponent };